import { Component, OnInit, OnDestroy } from '@angular/core';
import { UserService } from 'src/app/services/user/user.service';
import { User } from 'src/app/model/user.model';
import { Router } from '@angular/router';

//import 'rxjs/add/operator/map';
import { Subject } from 'rxjs';
//import { Http } from '@angular/http';
import { isNullOrUndefined } from 'util';
import { OrderService } from 'src/app/services/order/order.service';
import { ReportService } from 'src/app/services/reports/report.service';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-hrorderupload',
  templateUrl: './hrorderupload.component.html',
  styleUrls: ['./hrorderupload.component.css']
})
export class HrorderuploadComponent implements OnDestroy, OnInit {
  //dtOptions: DataTables.Settings = {};
  data: User;
  dtOptions: any = {};
  //dtTrigger: Subject = new Subject('');
  dtTrigger = new Subject<any>();

  constructor(private router: Router, private userService: UserService, private reportService : ReportService) {

  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }


  ngAfterViewInit() {

  }

  ngOnInit() {

    this.getVendorReport();

    this.dtOptions = {
      //ajax: JSON.stringify(this.data),
      // columns: [{
      //   title: 'ID',
      //   data: 'id'
      // }, {
      //   title: 'First name',
      //   data: 'firstName'
      // }, {
      //   title: 'Last name',
      //   data: 'lastName'
      // }],
      // Declare the use of the extension in the dom parameter
      dom: 'Bfrtip',
      // Configure the buttons
      buttons: [
        //'columnsToggle',
        //'colvis',
        'copy',
        'print',
        'excel'
        // ,{
        //   text: 'Some button',
        //   key: '1',
        //   action: function (e, dt, node, config) {
        //     alert('Button activated');
        //   }
        // }
      ]
    };

  }

  getVendorReport() {
    debugger;
    var currYear = new Date().getFullYear();
    var datef = "01-02-" + currYear;
    //var datet = "31-12-" + currYear;
    var datefrom = new Date(datef);
    var dateto = new Date();
    
    this.reportService.getHrOrderReport(datefrom, dateto).subscribe(
      (data: any) => {
        this.data = data;
        console.log(this.data);
        if (!isNullOrUndefined(this.data)) {
          this.dtTrigger.next();
        }
      }
    )
  }

  dateFilterSubmit(form : NgForm){
    if(form.value.datefrom > form.value.dateto)
    {
      alert("date from can't be greater than date to");
      form.reset();
      return false;
    }
    this.ngOnDestroy();
    console.log(form.value);
    this.reportService.getHrOrderReport(form.value.datefrom, form.value.dateto).subscribe(
      (data: any) => {
        this.data = data;
        console.log(this.data);
        if (!isNullOrUndefined(this.data)) {
          this.dtTrigger.next();
        }
      }
    )
  }

  // onEdit(id : string, name : string, index : number)
  // {
  //   alert(id);
  //   alert(name);
  // }

}
